/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketspayoutsneeded2Inputs */

const en_ticketspayoutsneeded2 = /** @type {(inputs: Ticketspayoutsneeded2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`To let guests buy paid tickets, set up payouts with Stripe once.`)
};

const de_ticketspayoutsneeded2 = /** @type {(inputs: Ticketspayoutsneeded2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Damit Gäste bezahlte Tickets kaufen können, richte einmal Auszahlungen mit Stripe ein.`)
};

/**
* | output |
* | --- |
* | "To let guests buy paid tickets, set up payouts with Stripe once." |
*
* @param {Ticketspayoutsneeded2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketspayoutsneeded2 = /** @type {((inputs?: Ticketspayoutsneeded2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketspayoutsneeded2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketspayoutsneeded2(inputs)
	return de_ticketspayoutsneeded2(inputs)
});
export { ticketspayoutsneeded2 as "ticketsPayoutsNeeded" }